import React from "react";
import TituloWrapper from "./style";

export default function Titulo({type, children }) {
  return (
    <TituloWrapper type={type}>
      <span>{children}</span>
    </TituloWrapper>
  );
}
